module.exports = "<app-header></app-header>\r\n<router-outlet></router-outlet>\r\n\r\n<app-footer></app-footer>\r\n"